"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.buttonVariants = exports.buttonColors = void 0;
var _react = _interopRequireDefault(require("react"));
var _SNETButtonModule = _interopRequireDefault(require("./SNETButton.module.css"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const buttonColors = exports.buttonColors = ["primary", "purple", "red"];
const buttonVariants = exports.buttonVariants = ["outlined", "contained"];
const SNETButton = _ref => {
  let {
    children,
    disabled,
    color = "primary",
    variant = "contained",
    onClick,
    className,
    ...rest
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("button", _extends({
    type: "button",
    className: (0, _classnames.default)(_SNETButtonModule.default["snet-button"], color && _SNETButtonModule.default[`snet-button-${color}`], variant && _SNETButtonModule.default[`snet-button-${variant}`], disabled && _SNETButtonModule.default[`snet-button-${disabled}`], className),
    disabled: disabled,
    onClick: onClick
  }, rest), children);
};
var _default = exports.default = SNETButton;
SNETButton.propTypes = {
  children: _propTypes.default.element,
  disabled: _propTypes.default.bool,
  color: _propTypes.default.oneOf(buttonColors),
  variant: _propTypes.default.oneOf(buttonVariants),
  onClick: _propTypes.default.func,
  className: _propTypes.default.string,
  rest: _propTypes.default.array
};